import consumer from "./consumer"

consumer.subscriptions.create("AiStreamChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    var messageContainer = document.querySelector("#markdown-editor");
    messageContainer.textContent += data.content;
  }
});
